package org.moxultimate.topwithmox.wallpaper.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class WallpaperResponse(
    @SerialName("id") val id: Long,
    @SerialName("title") val name: String,
    @SerialName("description") val description: String? = "",
    @SerialName("series") val series: String,
    @SerialName("type") val type: String = "",
    @SerialName("tags") val tags: String = "",
    @SerialName("resolution") val resolution: String = "",
    @SerialName("imagePath") val imagePath: String? = "",
    @SerialName("thumbnailPath") val thumbnailPath: String? = "",
    @SerialName("panoramaPath") val panoramaPath: String? = null,
    @SerialName("videoLink") val videoLink: String? = "",
    @SerialName("createdAt") val createdAt: String? = "",
)